import { PageCollection } from '@microsoft/microsoft-graph-client';
import { StorageGetNextListPage, StorageListPage } from '../common/list-page';
import { OneDriveFile, OneDriveItem } from './one-drive.item';

export class OneDriveListPage implements StorageListPage {
  constructor(
    private readonly storage: StorageGetNextListPage,
    private readonly result: PageCollection,
    private readonly onlyFolders: boolean,
    private readonly driveId?: string,
  ) {}

  public getItems(): OneDriveItem[] {
    return this.result.value
      .filter((file): file is OneDriveFile => typeof file.id !== 'undefined')
      .map((file) => new OneDriveItem(file, this.driveId));
  }

  public hasNext(): boolean {
    return !!this.result['@odata.nextLink'];
  }

  public async getNext(): Promise<StorageListPage> {
    if (!this.hasNext()) {
      throw new Error('Next page requested for the last page.');
    }

    return this.storage.getNextFolderPage(this.onlyFolders, {
      cursor: this.result['@odata.nextLink'],
      driveId: this.driveId,
    });
  }
}
